import React from 'react';
import Menu from '../../../components/Menu/Menu';
import MyHead from '../../../components/MyHead';
import Footer from '../../../components/Footer';
import ForgotPresentational from '../../../components/Forgot/ForgotPresentational';

const Forgot = () => {
  return (
    <>
      <MyHead />
      <div>
        <Menu />
        <ForgotPresentational />
        <Footer />
      </div>
    </>
  );
};

export default Forgot;
